import { z } from 'zod';

import { exploreColumnSchema } from './explore-column';

export type CreatePresetPayload = z.output<typeof createPresetPayloadSchema>;
export type CreatePresetPayloadDTO = z.input<typeof createPresetPayloadSchema>;

export const createPresetPayloadSchema = z.object({
  columns: z.array(exploreColumnSchema).min(1),
  name: z.string(),
});
